module.exports = __webpack_public_path__ + "img/0Q3C6212_Foamcore.7910a739.jpg";